import { render, staticRenderFns } from "./vm-facebook.vue?vue&type=template&id=4b09f36c&scoped=true&lang=pug&"
import script from "./vm-facebook.vue?vue&type=script&lang=js&"
export * from "./vm-facebook.vue?vue&type=script&lang=js&"
import style0 from "./vm-facebook.vue?vue&type=style&index=0&id=4b09f36c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b09f36c",
  null
  
)

export default component.exports